import Login_Account from "../components/Login_Account";
import { connect } from "react-redux";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
@connect(store => {
    return {
      isAuthenticated: store.loginreducer.isAuthenticated
    };
  })
  
export default class Login extends React.Component {
    constructor(props) {
      super(props);
    }
    componentDidMount() {
      if (this.props.isAuthenticated == false) {
        this.setState({ component: "login" });
      }
    }
    state = {
      component: "loading_userManagement"
    };
    componentWillReceiveProps(nextProps) {
      if (
        this.props.isAuthenticated != nextProps.isAuthenticated &&
        nextProps.isAuthenticated
      ) {
        this.setState({ component: "loading" });
      }
    }
    getRedirectPath() {
              return "/home";
        }
render() {
      if (this.props.isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: "/home",
            state: {
              from: this.props.location
            }
          }}
        />
      );
    }

    return (
        <div id = "mainLoginDiv">
          <Login_Account/>  
        </div>      
    );
  }
}